import * as vp from 'vopay';

import { FunctionComponent, useState, useEffect } from 'react';
import { startOfDay } from 'date-fns';
import styles from '../AccountingSystemOpen.module.scss';
import { useTranslation } from 'react-i18next';

import { Button } from '#shared/components/UI';

type AccountingSystemScheduleDialogueProps = {
  isVisible: boolean;
  defaultDate?: string;
  onSchedule: (savedValues: string) => void;
  close: () => void;
};
type FC = FunctionComponent<AccountingSystemScheduleDialogueProps>;

const AccountingSystemScheduleDialogue: FC = ({
  isVisible,
  close,
  defaultDate,
  onSchedule,
}: AccountingSystemScheduleDialogueProps) => {
  const { Modal, SubTitle, Box, DatepickerSimple } = vp;
  const [currentDate, setCurrentDate] = useState(defaultDate || '');
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.AccountingSystem.OpenTab.Dialogs.Schedule' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Shared' });

  useEffect(() => {
    setCurrentDate(defaultDate || '');
  }, [defaultDate]);

  return (
    <Modal isVisible={isVisible} enableBgClick={false}>
      <div className={styles.dialogueMini}>
        <Box flx="col" gapSize="12px">
          <SubTitle subTitle={t('title', { defaultValue: 'Edit Scheduled Date' })} center fontSize="16px" />

          <Box flx="col">
            <Box width="100%" gap="sm">
              <DatepickerSimple
                name="scheduledDate"
                variant="outline"
                isInline
                value={currentDate || ''}
                onBlur={() => {}}
                min={vp.createTimestamp(startOfDay(new Date()).getTime())}
                onChange={(event) => {
                  const selectedDate = event.target.value;
                  setCurrentDate(selectedDate);
                }}
              />
            </Box>
          </Box>

          <Box gap="sm" flx="row" jc="center">
            <Button
              id="save-schedule-date"
              colorScheme="primary"
              onClick={() => {
                onSchedule(new Date(Number(currentDate)).toLocaleDateString('en-ca'));
              }}
              style={{ width: '100%' }}
            >
              {t('confirmButton', { defaultValue: 'Confirm Date' })}
            </Button>

            <Button id="confirmationDialogue-close" colorScheme="secondary" style={{ width: '100%' }} onClick={close}>
              {tGlobal('Buttons.cancel', { defaultValue: 'Cancel' })}
            </Button>
          </Box>
        </Box>
      </div>
    </Modal>
  );
};

export default AccountingSystemScheduleDialogue;
